import { isArray } from 'lodash';
import {
  visitTypeRemoteCodes,
  visitTypePhoneCodes,
  coxaAdditionalInfoResources,
  TYPE_COXA_TREATMENT_PERIOD,
} from '../definitions/TimelineItems';
import Api from '../api/Api';

/**
 * Get displayed name for a department. Removes abbreviation inside parentheses
 * @param department
 * @returns {*}
 */
export const getDepartmentDisplay = (department) => {
  return department ? department.replace(/\(.*\)/, '') : department;
};

/**
 * Get abbreviation for a department
 * @param department
 * @returns {*}
 */
export const getDepartmentabbreviation = (department) => {
  const reg = /\((.*)\)/;
  return department
    ? reg.exec(department) && reg.exec(department)[1].trim()
    : department;
};

export const mapVisibleQuestionnaires = (data) => {
  let visibleQuestionnaires = [];
  if (data.questionnaire) {
    visibleQuestionnaires = data.questionnaire;
  }

  return visibleQuestionnaires;
};

/**
 * Check if visit is a remote visit.
 *
 * A visit is a remote visit if it's visit type code is found in the
 * visitTypeRemoteCodes list.
 *
 *
 * @param data
 * @returns {boolean}
 */
export const isRemoteVisit = (data) => {
  return visitTypeRemoteCodes().indexOf(data.visitTypeCode) >= 0;
};

/**
 * Check if visit is a phone call.
 *
 * A visit is a phone call if it's visit type code is found in the
 * visitTypePhoneCodes list.
 *
 *
 * @param data
 * @returns {boolean}
 */
export const isPhoneVisit = (data) => {
  return visitTypePhoneCodes().indexOf(data.visitTypeCode) >= 0;
};

/**
 * Check whether there are assigned instructions for the given appointment.
 * Instructions are fetched from linkkipalvelu.
 *
 * Currently returns common instructions only.
 *
 * @param appointment
 * @param linkkipalvelu
 * @returns {null|boolean}
 */
export const getInstructions = (appointment, linkkipalvelu) => {
  const instructions = linkkipalvelu.Ohjeet;

  if (!instructions) {
    return null;
  } else if (
    isArray(instructions.coxa) &&
    appointment.department.toLowerCase().includes('coxa')
  ) {
    return instructions.coxa;
  } else {
    return instructions.common;
  }
};

export const hasInstructions = (appointment, linkkipalvelu) => {
  let instructions = getInstructions(appointment, linkkipalvelu);

  if (!instructions) return false;

  return isArray(instructions) && instructions.length > 0;
};

export const hasLinkkipalveluLinkValue = (linkValue) => {
  return (
    linkValue &&
    linkValue.length !== 0 &&
    linkValue !== 'fetching' &&
    linkValue !== 'error' &&
    linkValue !== null &&
    linkValue[0] !== null &&
    linkValue.toString() !== '' &&
    linkValue.toString() !== ' '
  );
};

/**
 * Check if coxa resource is listed to have an additional info
 *
 * @param data
 * @returns {boolean}
 */
export const hasAdditionalCoxaInfo = (data) => {
  return (
    data.type != TYPE_COXA_TREATMENT_PERIOD &&
    coxaAdditionalInfoResources().indexOf(data.oid) >= 0
  );
};

export const hasLinkValue = (linkValue) => {
  return linkValue &&
      linkValue.length !== 0 &&
      linkValue !== 'fetching' &&
      linkValue !== 'error' &&
      linkValue !== null &&
      linkValue[0] !== null &&
      linkValue.toString() !== '' &&
      linkValue.toString() !== ' '
};

export const getVideoConferenceLink = () => {
  Api.getVideoConferenceLink()
    .then((data) => {
      window.open(data, '_blank', 'noopener');
    })
    .catch(() => {
      alert('Sinua ei voitu ohjata videovastaanottoon.');
    });
};
